// extracted by mini-css-extract-plugin
export default {"Photos":"Photos_Photos__rkq+J","carousel-photo":"Photos_carousel-photo__+BsGI"};